import * as Yup from 'yup';

export const getInitialValues = (email:string) => {
    return {
        email: email || '',
        code: ['', '', '', '', '', ''],
    }
};

export const validationSchema = Yup.object({
  email: Yup.string()
    .email('Must be a valid email')
    .required('Email is required'),
  code: Yup.array()
    .of(Yup.string().required('Code is required')),
});
